export default (that) => [
  {
    text: that.$l('menu_text_detail') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('menu_text_edit') || '编辑单据',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    disabled: ({ evgPurchaseStatus }) => {
      return !['N', 'R'].includes(evgPurchaseStatus)
    },
  },
  {
    text: that.$l('menu_text_delete') || '删除单据',
    icon: 'el-icon-delete',
    menuType: 'delete',
    allow: 'D',
    disabled: ({ evgPurchaseStatus }) => {
      return !['N', 'R'].includes(evgPurchaseStatus)
    },
  },
  {
    text: that.$l('menu_text_submit') || '提交审核',
    icon: 'el-icon-s-check',
    menuType: 'submit',
    divided: true,
    allow: 'S',
    disabled: ({ evgPurchaseStatus }) => {
      return !['N', 'R'].includes(evgPurchaseStatus)
    },
  },
  {
    text: that.$l('menu_text_audit') || '审核单据',
    icon: 'el-icon-check',
    menuType: 'audit',
    allow: 'Y',
    disabled: ({ evgPurchaseStatus }) => evgPurchaseStatus !== 'S',
  },
  {
    text: that.$l('menu_text_export') || '导出合同',
    icon: 'el-icon-download',
    menuType: 'export',
    divided: true,
    allow: 'E',
    disabled: ({ evgPurchaseStatus }) => evgPurchaseStatus !== 'Y',
  },
]
